import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportPrepaid } from "../api";
import { ApiDateTimeFormat, ToDateText } from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsData = [
  { id: "SRC_TYPE", label: "SRC_TYPE", minWidth: 170, align: "left" },
  {
    id: "T1",
    label: "T1",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "T2",
    label: "T2",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "DIFF_T1T3",
    label: "DIFF_T1T3",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
];
const customheaderData = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={2} align="center">
          Source Type
        </TableCell>
        <TableCell colSpan={4} align="center">
          DTN
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">EDW T1</TableCell>
        <TableCell align="center">EDW T3</TableCell>
        <TableCell align="center">Diff(T1-T3)</TableCell>
      </TableRow>
    </TableHead>
  );
};
function Prepaid() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [Data_lst, setData_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportPrepaid(param));
    if (!dat) return;
    setData_lst(dat?.Data?.Rows);
    setDate(ToDateText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query()
  }, [query]);

  //changeColor(columnsDom, "DIF", Dom_lst[0]?.DIFF_COLOR_CODE);
  return (
    <FormProvider {...methods}>
      <BaseContainer>
        {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4">Prepaid revenue report</Typography>
        </Box>
        <Criteria query={query} />
        <Box display="flex" justifyContent="center">{`Date :${
          date || ""
        }`}</Box>
        <ReportTable
          data={Data_lst}
          columns={columnsData}
          header={customheaderData}
          cellColor={[{ fieldId: "DTN_DIFF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
      </BaseContainer>
    </FormProvider>
  );
}
export default withLoadingContext(Prepaid);
